module.exports = __webpack_public_path__ + "media/images/services/04-b2dfe42000911016bf6f0c6d5bb78013.jpg";